<template>
  <div id="app" v-if="showPage">
    <van-nav-bar :left-arrow="arrowShow" @click-left="onClickLeft">
      <template #left>
        <van-icon v-if="isNtplat && !arrowShow" name="cross" size="18" @click="closePage" />
      </template>
      <template #title>
        <img src="@/assets/logo.png" class="logo" />
      </template>
      <template v-if="popUpShow" #right>
        <van-icon name="manager-o" size="18" @click="popShow = true" />
      </template>
    </van-nav-bar>
    <van-popup v-model="popShow" position="top">
      <van-cell v-if="managerShow" :title="$t('consumeRecord')" is-link @click="toConsumePage" />
      <van-cell v-if="managerShow && appId == '1019'" :title="$t('precautions')" is-link @click="toAgreement" />
      <van-cell v-if="
        env !== 'cn' &&
        pageLang !== 'ja-JP' &&
        pageLang !== 'ru-RU' &&
        pageLang !== 'ko-KR'
      " :title="$t('langChange')" is-link @click="langPopShow" />
      <van-cell v-if="!isNtplat && (managerShow || managerElseShow)" :title="$t('roleChange')" is-link
        @click="toRolePage" />
      <van-cell v-if="!isNtplat && (managerShow || managerElseShow)" :title="$t('logNewRole')" is-link
        @click="toLoginPage" />
      <van-cell v-if="toggleFlag && !pwdFlag" :title="$t('setPayPwd')" is-link @click="toPwdPage" />
      <van-cell v-if="toggleFlag && !emailFlag" :title="$t('toSetEmail')" is-link @click="toEmailPage" />
      <van-cell v-if="toggleFlag && pwdFlag" :title="$t('changePayPwd')" is-link @click="toChangePwdPage" />
      <van-cell v-if="toggleFlag && pwdFlag && emailFlag" :title="$t('forgetPayPwd')" is-link
        @click="toforgetPwdPage" />
      <van-cell v-if="toggleFlag && emailFlag" :title="$t('checkEmail')" is-link @click="toEmailSuccseePage" />
    </van-popup>
    <van-popup v-model="langShow" position="top">
      <van-cell :title="$t('simpleChinese')" is-link @click="changeLang('zh-CN')" />
      <van-cell :title="$t('ulChinese')" is-link @click="changeLang('zh-TW')" />
      <van-cell :title="$t('english')" is-link @click="changeLang('en-US')" />
      <van-cell :title="$t('india')" is-link @click="changeLang('id-ID')" />
      <van-cell :title="$t('thai')" is-link @click="changeLang('th-TH')" />
      <!-- <van-cell v-if="appId == '1018'" :title="$t('russian')" is-link @click="changeLang('ru-RU')"/> -->
    </van-popup>
    <van-notice-bar v-if="appId == '1002'" left-icon="volume-o" :text="$t('weekText')" />
    <van-notice-bar v-else left-icon="volume-o" :text="$t('incognitoError')+(appId == '1019'?' 공식 웹상점에서 결제(현금, 포인트) 시, 게임 내 충전 포인트가 정상적으로 반영됩니다.':'')" />
    <router-view @toggleFlag="toggleFlagQuery" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Vuei18n from "vue-i18n";
import { Dialog, Toast } from "vant";
export default {
  name: "App",
  data() {
    return {
      path: "",
      toggleFlag: false,
      pwdFlag: false,
      emailFlag: false,
      arrowShow: false,
      env: "",
      pageLang: "",
      popShow: false,
      managerShow: false,
      popUpShow: false,
      langShow: false,
      managerElseShow: false,
      isNtplat: false,
      appId: "",
      isMobile: navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      ),
    };
  },
  created() {
    this.showArrow()
    var fs = window.RequestFileSystem || window.webkitRequestFileSystem;
    if (!fs) {
      console.log("check failed");
    } else {
      fs(
        window.TEMPORARY,
        100,
        function () {
          // alert('非隐身模式');
        },
        function () {
          Dialog.alert({
            message: this.$t("incognitoError"),
            showConfirmButton: false,
            closeOnClickOverlay: false,
            cancelButtonText: this.$t("cancel"),
            confirmButtonText: this.$t("sure"),
          });
          // alert('隐身模式');
        }
      );
    }
  },
  methods: {
    ...mapActions(["getUserPointSwitch", "getVersion"]),
    // 显示左侧箭头
    showArrow(managerElseStatus) {
      let arrowWhiteList = ["consume", "forgetpwd", "changepwd", "setpwd", "setpwdstep2", "bindemail", "bindsuccess", 'agreement'];
      let pathName = this.$route.matched[0].path.split("/")[1];
      this.arrowShow = false
      this.managerElseShow = false
      if (arrowWhiteList.includes(pathName)) {
        this.arrowShow = true;
        if (managerElseStatus) {
          this.managerElseShow = true;
        }
      }
    },
    // 显示头像及选择区域
    showPopUp() {
      let popUpWhiteList = ["paylogin", "changepwd", "setpwd", "setpwdstep2", "bindemail", "bindsuccess", "detail", 'finishdetail', 'agreement'];
      let langWhiteList = ["ja-JP", "ru-RU", "ko-KR"];
      console.log(this.$route);
      
      let pathName = this.$route.matched[0].path.split("/")[1];
      let status = langWhiteList.includes(this.pageLang)
      if (
        (pathName === "login" && this.env == "cn") ||
        (pathName === "login" && status) ||
        (pathName === "consume" && status) ||
        pathName.includes(popUpWhiteList)
      ) {
        this.popUpShow = false;
      } else {
        this.popUpShow = true;
      }
    },
    async toggleFlagQuery(val, pwdVal, emailVal) {
      this.toggleFlag = val;
      this.pwdFlag = pwdVal;
      this.emailFlag = emailVal;
    },
    changeLang(lang) {
      window.localStorage.setItem("language", lang);
      window.i18n.locale = lang;
      this.langShow = false;
    },
    langPopShow() {
      this.langShow = true;
      this.popShow = false;
    },
    toChangePwdPage() {
      this.getUserPointSwitch({
        accessToken: window.localStorage.getItem("accessToken"),
        appId: window.localStorage.getItem("appId"),
        language: window.localStorage.getItem("language"),
      });
      this.path = "/changePwd";
    },
    toforgetPwdPage() {
      this.getUserPointSwitch({
        accessToken: window.localStorage.getItem("accessToken"),
        appId: window.localStorage.getItem("appId"),
        language: window.localStorage.getItem("language"),
      });
      this.path = "/forgetPwd";
    },
    toEmailSuccseePage() {
      this.getUserPointSwitch({
        accessToken: window.localStorage.getItem("accessToken"),
        appId: window.localStorage.getItem("appId"),
        language: window.localStorage.getItem("language"),
      });
      this.path = "/bindsuccess";
    },
    toPwdPage() {
      this.getUserPointSwitch({
        accessToken: window.localStorage.getItem("accessToken"),
        appId: window.localStorage.getItem("appId"),
        language: window.localStorage.getItem("language"),
      });
      this.path = "/setPwd";
    },
    toEmailPage() {
      this.getUserPointSwitch({
        accessToken: window.localStorage.getItem("accessToken"),
        appId: window.localStorage.getItem("appId"),
        language: window.localStorage.getItem("language"),
      });
      this.path = "/bindEmail";
    },
    toConsumePage() {
      this.$router.push({
        path: "/consume",
      });
      this.popShow = false;
    },
    toAgreement() {
      this.$router.push({
        path: "/agreement",
      });
      this.popShow = false;
    },
    toLoginPage() {
      Dialog.confirm({
        title: this.$t("sureAgain"),
        message: this.$t("sureChangeAgain"),
        cancelButtonText: this.$t("cancel"),
        confirmButtonText: this.$t("sure"),
      })
        .then(() => {
          this.$router.push({
            path: "/login",
            query: {
              from: "exit",
            },
          });
        })
        .catch(() => {
          // on cancel
        });
      this.popShow = false;
    },
    toRolePage() {
      Dialog.confirm({
        title: this.$t("sureAgain"),
        message: this.$t("roleChangeAgain"),
        cancelButtonText: this.$t("cancel"),
        confirmButtonText: this.$t("sure"),
      })
        .then(() => {
          this.$router.push({
            path: "/login",
            query: {
              from: "store",
            },
          });
        })
        .catch(() => {
          // on cancel
        });
      this.popShow = false;
    },
    onClickLeft() {
      this.path = "";
      if (
        this.$route.matched[0].path.split("/")[1] === "consume" ||
        this.$route.matched[0].path.split("/")[1] === "bindsuccess"
      ) {
        if (this.$route.query.from == "paylogin") {
          this.$router.push({
            path: "/paylogin",
          });
        } else {
          this.$router.push({
            path: "/store",
          });
        }
        this.popShow = false;
      } else {
        this.$router.go(-1);
      }
    },
    closePage() {
      (typeof ntAndroidWeb !== "undefined" && ntAndroidWeb.webClose()) ||
        (window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.webClose.postMessage(null));
    },
  },
  computed: {
    ...mapGetters([
      "pointSwitch",
      "uwLoading",
      "versionData",
      "vLoading",
      "showPage",
    ]),
    formatDate: (val) => {
      return (val) => {
        return moment(val).format("YYYY-MM-DD HH:mm:ss");
      };
    },
  },
  mounted() {
    this.getVersion();
    if (
      typeof ntAndroidWeb !== "undefined" ||
      (window.webkit && window.webkit.messageHandlers)
    ) {
      this.isNtplat = true;
    } else {
      this.isNtplat = false;
    }
    this.env = CONFIG.env;
    // if(!window.localStorage.getItem('language')){
    if (CONFIG.env == "cn") {
      window.localStorage.setItem("language", "zh-CN");
      window.i18n.locale = "zh-CN";
    } else {
      let lang = this.$route.query.lang ||
        window.localStorage.getItem("language") ||
        "en-US";
      window.localStorage.setItem("language", lang);
      window.i18n.locale = lang
      this.pageLang = lang
      // window.localStorage.setItem('language', 'en-US')
      // window.i18n.locale = 'en-US'
    }
    this.appId = window.localStorage.getItem("appId");
    
    // } else {
    //   window.i18n.locale = window.localStorage.getItem('language')
    //   this.pageLang = window.localStorage.getItem('language')
    // }
    // if(!this.isMobile){
    // Dialog.alert({
    //   message: this.$t('pcError'),
    //   showConfirmButton: false,
    //   closeOnClickOverlay: false,
    //   cancelButtonText: this.$t('cancel'),
    //   confirmButtonText: this.$t('sure')
    // })
    // }
    this.showPopUp();
    this.showArrow(true);
    if (this.$route.matched[0].path.split("/")[1] === "content") {
      this.managerElseShow = true;
    } else {
      this.managerElseShow = false;
    }
    if (window.location.pathname.split("/")[1] == "store") {
      this.managerShow = true;
    } else {
      this.managerShow = false;
    }
    this.$watch("showPage", () => {
      document.title = this.$t("title");
    });
    this.$watch(
      () => this.$route,
      (val) => {
        this.path = "";
        this.showPopUp();
        this.showArrow(true);
        if (window.location.pathname.split("/")[1] == "store") {
          this.managerShow = true;
        } else {
          this.managerShow = false;
        }
        if (this.$route.matched[0].path.split("/")[1] === "content") {
          this.managerElseShow = true;
        } else {
          this.managerElseShow = false;
        }
        this.appId = window.localStorage.getItem("appId");
      }
    );

    this.$watch("uwLoading", (val) => {
      if (val == "loaded") {
        if (this.path) {
          if (this.pointSwitch.ruleSwitch.quantityDisplay) {
            this.$router.push({
              path: this.path,
            });
            this.popShow = false;
          } else {
            Toast({
              message: this.$t("rebateClosed"),
              type: "fail",
            });
          }
        }
      }
    });
    this.$watch("vLoading", (val) => {
      if (val === "stated") {
        const v = "v1.1";
        if (this.versionData.version && this.versionData.version !== v) {
          Dialog.alert({
            message: this.$t("versionError"),
            showConfirmButton: false,
            closeOnClickOverlay: false,
          });
        }
      }
    });
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

.van-nav-bar {
  // width: 100%;
  background-color: #e60012;
  z-index: 100000;
}

body {
  background-color: #f7f7f7;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.van-nav-bar__title {
  line-height: 1;
}

.logo {
  height: 20px;
  line-height: 46px;
  // bottom: 14px;
  // position: absolute;
}

.van-nav-bar__left {
  .van-icon {
    color: #fff;
  }
}

.van-nav-bar .van-icon {
  color: #fff;
}

.van-popup {
  margin-top: 46px;
}
</style>
